import NextLink from 'next/link';
import PropTypes from 'prop-types';

import Heading from 'shopper/components/Heading';

import Anchor from 'components/Anchor';

import placeholder from 'lib/placeholder';

const StoresList = ({
  storesSeparatedByAlphabeticalOrder,
  storeUrlFormatterFn,
  ...rest
}) => (
  <div {...rest}>
    <Heading as="h1" className="md:mb-1" size="size3">
      {placeholder('titles.allStores')}
    </Heading>
    {Object.entries(storesSeparatedByAlphabeticalOrder).map(
      ([firstLetter, stores]) => (
        <div
          key={firstLetter}
          className="mt-8 border-b border-neutral-high-300 pb-8 last:border-b-0 dark:border-neutral-low-100"
        >
          <Heading className="w-10 md:w-[60px]" size="size2">
            {firstLetter}
          </Heading>
          <div className="grid grid-cols-1 gap-y-6 md:grid-cols-3 md:gap-y-8">
            {stores.map((store, storeIndex) => (
              <div
                key={storeIndex}
                className="ml-10 flex items-center justify-start md:ml-0 md:justify-center"
              >
                <NextLink
                  href={storeUrlFormatterFn(store.pageParam)}
                  prefetch={false}
                  passHref
                >
                  <Anchor>{store.pageTitle}</Anchor>
                </NextLink>
              </div>
            ))}
          </div>
        </div>
      )
    )}
  </div>
);

StoresList.propTypes = {
  storeUrlFormatterFn: PropTypes.func.isRequired,
  storesSeparatedByAlphabeticalOrder: PropTypes.shape({
    [PropTypes.string]: PropTypes.arrayOf(
      PropTypes.shape({
        pageTitle: PropTypes.string.isRequired,
        pageFrom: PropTypes.string.isRequired,
        pageImage: PropTypes.string.isRequired,
        pageParam: PropTypes.string.isRequired,
      })
    ),
  }).isRequired,
};

export default StoresList;
